(() => {
  'use strict';
  const dialogs = new WeakMap();
  function dialogState() {
    // Quantity changes replace the cart section, including its dialog.
    const dialog = document.getElementById('NettCartDesignPreview');
    if (!dialog || typeof dialog.showModal !== 'function') return null;
    if (dialogs.has(dialog)) return dialogs.get(dialog);
    const image = dialog.querySelector('[data-nett-preview-image]');
    const closeButton = dialog.querySelector('[data-nett-preview-close]');
    const title = dialog.querySelector('#NettCartDesignPreviewTitle');
    if (!image || !closeButton) return null;
    const status = document.createElement('p');
    status.className = 'nett-cart-preview__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    image.before(status);
    const state = { dialog, image, closeButton, title, status, returnFocus: null, request: 0 };
    dialogs.set(dialog, state);
    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      state.request += 1;
      image.onload = null;
      image.onerror = null;
      image.removeAttribute('src');
      image.hidden = true;
      status.hidden = true;
      if (state.returnFocus?.isConnected) state.returnFocus.focus({ preventScroll: true });
      state.returnFocus = null;
    });
    return state;
  }
  document.addEventListener('error', event => {
    const image = event.target;
    const trigger = image?.closest?.('[data-nett-preview-trigger]');
    const fallback = image?.getAttribute?.('data-nett-preview-fallback');
    if (!trigger?.closest('.nett-cart') || !fallback) return;
    // One attempt only; the original design stays available if the mockup fails.
    image.removeAttribute('data-nett-preview-fallback');
    trigger.removeAttribute('data-nett-product-preview');
    image.classList.remove('nett-cart__product-image');
    image.alt = 'Vorschau deines Designs';
    const label = trigger.querySelector('.nett-cart__design-media-label');
    if (label) label.textContent = 'Design ansehen';
    image.src = fallback;
  }, true);
  document.addEventListener('click', event => {
    const trigger = event.target?.closest?.('[data-nett-preview-trigger]');
    if (!trigger?.closest('.nett-cart')) return;
    const source = trigger.querySelector('img');
    const src = source?.getAttribute('src');
    if (!src) return;
    const state = dialogState();
    if (!state) return;
    const { dialog, image, closeButton, title, status } = state;
    const revision = ++state.request;
    state.returnFocus = trigger;
    if (title) title.textContent = trigger.getAttribute('data-nett-product-preview') === 'true' ? 'Dein Produkt mit deinem Design' : 'Dein Design';
    image.hidden = true;
    image.alt = source.alt || 'Vorschau deines Designs';
    status.hidden = false;
    status.textContent = 'Vorschau wird geladen …';
    image.onload = () => {
      if (revision !== state.request || !dialog.open) return;
      image.hidden = false;
      status.hidden = true;
      status.textContent = '';
    };
    image.onerror = () => {
      if (revision !== state.request || !dialog.open) return;
      image.hidden = true;
      status.hidden = false;
      status.textContent = 'Die Vorschau konnte nicht geladen werden. Dein Design bleibt der Bestellung zugeordnet.';
    };
    if (!dialog.open) dialog.showModal();
    image.src = src;
    closeButton.focus();
  });
})();
